<template>
  <div>
    <menu-pae />
    <filtro-pesquisa-busca-geral
      :rowsNumber="10"
      :eventBusDataName="eventBusDataName"
      :eventBusPaginationName="eventBusPaginationName"
    />

    <div class="container-xl">
      <lista-protocolos
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
      />
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import filtroPesquisaBuscaGeral from '@/components/buscaGeral/FiltroPesquisaBuscaGeral'
import listaProtocolos from '@/components/buscaGeral/listaProtocolos'

export default {
  components: {
    menuPae,
    filtroPesquisaBuscaGeral,
    listaProtocolos
  },

  data () {
    return {
      eventBusDataName: 'consultaProcessoApensado',
      eventBusPaginationName: 'consultaProcessoApensadoDataPagination',
      colNames: ['Protocolo', 'Autor', 'Departamento', 'Assunto', 'Ações'],
      colWidth: [20, 10, 20, 30, 20],
      dataTableColumn: [{
        column: 'processo',
        converter: 'protocolo'
      }, 'atributos.autor', 'atributos.descricaoDepartamento', 'atributos.assunto']
    }
  },

  methods: {
    visualizar (obj) {
      var isApensado = obj.atributos.apensadoEm && obj.atributos.apensadoEm !== ''
      this.$router.push({ name: 'visualizadorProcesso', query: { numeroProcesso: obj.atributos.numeroProcesso.replace(/\//g, ''), apensado: isApensado } })
    }
  }
}
</script>
